import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DashboardRecruitmentCfgService, RecruitmentCenterCfg } from './dashboard-recruitment-cfg.service';
import { DashboardRecruitmentResponseModel } from '../models/dashboardRecruitment.model';
import { OfficeSelectorService } from 'src/app/common/officeSelector/officeSelector.service';
import { KpiService } from 'src/app/dashboardCommon/services/kpiService';
import { KpiServiceError, KpiServiceErrorType } from 'src/app/dashboardCommon/services/kpiServiceError';
import { ApigeeService } from 'src/app/auth/apigee/apigee.service';

@Injectable()
export class DashboardRecruitmentService extends KpiService<DashboardRecruitmentResponseModel> {

  public getClassName() { return "DashboardRecruitmentService"; }

  constructor(
    private serviceCfg: DashboardRecruitmentCfgService,
    private apigeeService: ApigeeService,
    private officeSelectorService: OfficeSelectorService,
    private httpClient: HttpClient,
    injector: Injector
  ) {
    super(injector);
  }

  protected async update(): Promise<DashboardRecruitmentResponseModel> {
    if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
      let result: DashboardRecruitmentResponseModel = null;
      try {
        let cfg: RecruitmentCenterCfg = this.serviceCfg.getCfg();
        let url = cfg.bucketRecruitmentEndPointPattern.format(this.apigeeService.userInfo.sub);
        result = await this.httpClient.get<DashboardRecruitmentResponseModel>(url).toPromise();

        if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
        else return result;
      } catch (error) {
        let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
        throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
      }
    } else {
      throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
    }
  }
}